// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1RI5W","author":"Table_author__6u3X1","authorImage":"Table_authorImage__2O3eF","unreadRow":"Table_unreadRow__2pKn_"};